// extracted by mini-css-extract-plugin
export default {"row":"Row_row__+YRX-","alignTop":"Row_alignTop__p3Laa"};